import {Injectable} from '@angular/core';
import {FormDataService} from "../data/form-data.service";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class StepThreeGuardService {

  constructor(private formData: FormDataService, public router: Router) {
  }

  canActivate(): boolean {
    if (!this.formData.activeSteps['step_3']) {
      this.router.navigate(['/admin/new-order/type']);
      return false;
    }
    return true;
  }
}
